import { useAction } from "@/hooks/shared";
import { generateBenchmarkHandler } from "@/services";

export const useGenerateBenchmark = () => useAction(generateBenchmarkHandler);
